import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CURRENCY, CURRENCY_UNIT, UNIT } from '../../utils/currency'
import { positionDropdown } from '../dropdown'
import { SelectCustom } from '../selectCustom'
import { SCROLL_ID_HIDDEN } from './constant'
import classes from './index.module.scss'
import { changeCurrency, changeUnit, selectCurrency, selectUnit } from './slice'

export const SelectCurrencyUnit = ({ screen, fixedCurrency }) => {
  const dispatch = useDispatch()

  const currency = useSelector(selectCurrency(screen))
  const unit = useSelector(selectUnit(screen))

  const handleChooseCurrency = ({ value }) => {
    if (currency !== value) {
      dispatch(changeCurrency({ screen, value }))
      dispatch(changeUnit({ screen, value: UNIT.SINGLE.unitKey }))
    }
  }

  const handleChooseCurrencyUnit = ({ value }) => {
    dispatch(changeUnit({ screen, value: value }))
  }

  useEffect(() => {
    if (fixedCurrency) {
      dispatch(changeCurrency({ screen, value: fixedCurrency }))
      if (!CURRENCY_UNIT[fixedCurrency].includes(unit)) {
        dispatch(changeUnit({ screen, value: UNIT.SINGLE.unitKey }))
      }
    }
  }, [])

  return (
    <div className={classes.container}>
      <Translate value="companyAnalysis.common.CURRENCY_UNIT" />
      <SelectCustom
        activeItem={{ value: currency }}
        data={Object.values(CURRENCY).map((item) => ({
          label: item,
          value: item,
          disabled: fixedCurrency && item !== fixedCurrency,
        }))}
        chooseItem={handleChooseCurrency}
        style={{
          marginRight: 4,
          fontSize: 12,
          padding: '4px 12px',
        }}
        scrollId={SCROLL_ID_HIDDEN}
      />
      <SelectCustom
        activeItem={{ value: unit }}
        data={CURRENCY_UNIT[currency].map((unitKey) => ({
          label: UNIT[unitKey].label,
          value: unitKey,
          isI18n: true,
        }))}
        isI18n
        chooseItem={handleChooseCurrencyUnit}
        style={{
          fontSize: 12,
          padding: '4px 12px',
        }}
        dropdownPosition={positionDropdown.BOTTOM_END_LEFT}
        scrollId={SCROLL_ID_HIDDEN}
      />
    </div>
  )
}
